import React, { useEffect, useState } from 'react';
import intl from 'react-intl-universal';
import { Button } from 'antd';
import BundleProdPlanDetail from './BundleProdPlanDetail';
import ProdIcon from '@/assets/PaymentDlg/prod.svg';
import { paymentApi } from '@/api/index';
import { useUserCountry, useUserCurrency } from './PaymentHook';
import { store } from 'Store/store.index';
import { DEVICE_DETACTION } from 'Utils/device';
import RoleList from './RoleList';
import ProductList from './ProductList';
import { SUBSCRIBE_ACTION_MAP } from 'Components/viewer/ui/constants/event.constants.share';

const BundleProdCard = (props) => {
  const { selectCard, isSel, info: { name, show_name, sku, ga_event, app_code, app_code_win, app_code_mac } } = props;
  const buyNow = intl.formatMessage({ id: 'account.BuyNow' });
  const HighRoi = intl.formatMessage({ id: 'account.HighRoi' });
  const EduPlanInclude = intl.formatMessage({ id: 'account.EduPlanInclude' });

  const { code: country, is_eu: isEuCountry } = useUserCountry();
  const { currency: { currency_code: currency }, currencyList } = useUserCurrency();
  const ip = store.appStore.phantomOnlineGlobalConfig.userIp || '';
  const [license, setLicense] = useState('monthly-year');
  const [licensePrice, setLicensePrice] = useState(0);
  const [licenseCurrency, setLicenseCurrency] = useState('');
  const [licenseSymbol, setLicenseSymbol] = useState('');
  const [planDetail, setPlanDetail] = useState({});
  const [appCode, setAppCode] = useState('');
  const { isEdu } = store.userStore;

  useEffect(() => {
    if(app_code === 'pdf_editor_cloud_education'){
      setLicense('yearly');
    }

    if (app_code) {
      setAppCode(app_code);
      return;
    }

    if (DEVICE_DETACTION.windows && app_code_win) {
      setAppCode(app_code_win);
      return;
    }

    if (DEVICE_DETACTION.mac && app_code_mac) {
      setAppCode(app_code_mac);
    }

  }, [app_code, app_code_win, app_code_mac]);

  const getPrice = async (changedCurrency = '') => {
    const _cy = changedCurrency ? changedCurrency : currency;
    setLicenseCurrency(_cy);

    const res = await paymentApi.getPaymentPlans({
      country,
      currency: _cy,
      ip,
      app_code: appCode,
      language: 'en-US',
      token: store.userStore.token,
    });

    if (res.code === 200 && res.message.toLowerCase() === 'success') {
      let realPrice = {};
      if ('windows' in res.data) {
        realPrice = res.data.windows;
      } else if ('mac' in res.data) {
        realPrice = res.data.mac;
      }
      setPlanDetail({ ...res.data, ...realPrice });
    }

    if (!isSel) {
      store.appStore.showLoading(false);
    }
  };

  useEffect(() => {
    if (appCode && currency && country) {
      getPrice();
    }
  }, [appCode, country, currency]);

  const addToShoppingCar = () => {
    if (!isEdu) {
      const { eventKey, label } = SUBSCRIBE_ACTION_MAP[ga_event];
      store.userStore.doSendGAEventByUser({ eventKey, label });

      store.userStore.addToStoreShoppingCar({ license, sku });
      return;
    }
    window.pdfui.eventEmitter.emit('need-pay-event', false, '',
      { isEduBuy: true, name, show_name, appCode, license, licensePrice, licenseCurrency, licenseSymbol, country, isEuCountry: !!isEuCountry });
  };

  return (
    <div className={`bundle-card-box ${isSel ? 'on' : ''}`} onClick={selectCard}>
      {appCode === 'pdf_editor_ps_business_pro' && <span className='high-roi'>{HighRoi}</span>}
      <div className='bcb-title'>
        <img src={ProdIcon} alt={name} />
        <span dangerouslySetInnerHTML={{ __html: show_name }}></span>
      </div>
      <BundleProdPlanDetail
        plans={planDetail} appCode={appCode} currencyList={currencyList}
        getPrice={getPrice} setLicense={setLicense} setLicensePrice={setLicensePrice}
        setLicenseSymbol={setLicenseSymbol}
      />
      <Button type='primary' onClick={addToShoppingCar}>{buyNow}</Button>
      {isEdu && (
        <>
          <p className='edu-plan-include'>{EduPlanInclude}:</p>
          {appCode === 'pdf_editor_ps_education_pro' && <ProductList small />}
          {appCode === 'pdf_editor_cloud_education' && <RoleList small />}
        </>
      )}
    </div>
  );
};
export default BundleProdCard;